/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".CustomTable table{border-collapse:collapse;min-width:400px}.CustomTable tr{border:1px solid #ccdbe1;height:29px}.CustomTable table thead th{font-weight:600;vertical-align:bottom;background-color:#eceff1;color:#000}.CustomTable table td,.CustomTable table th{line-height:20px;padding:4px 4px 4px 10px;text-align:left;border:1px solid #ccdbe1}.ImportErrorGrid tbody td{padding:4px 4px 4px 0}"];
export { styles as styles };
